<template>
    <div>
      <v-tabs
          v-if="!is_searched"
          v-model="tab"
          background-color="#eef2f4"
          centered
          class="elevation-0 d-grid"
          @change="$emit('change_tab',tab)"
          color="#ff8080"
          fixed-tabs
          icons-and-text
      >
        <v-tab href="#tab-1">
          <div v-if="tab==='tab-1'">ثبت شده</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4133 10.6667H29.588C33.7067 10.6667 36 13.0401 36 17.1067V30.8801C36 35.0134 33.7067 37.3334 29.588 37.3334H18.4133C14.36 37.3334 12 35.0134 12 30.8801V17.1067C12 13.0401 14.36 10.6667 18.4133 10.6667ZM18.7733 16.8801V16.8667H22.7587C23.3333 16.8667 23.8 17.3334 23.8 17.9054C23.8 18.4934 23.3333 18.9601 22.7587 18.9601H18.7733C18.1987 18.9601 17.7333 18.4934 17.7333 17.9201C17.7333 17.3467 18.1987 16.8801 18.7733 16.8801ZM18.7733 24.9867H29.2267C29.8 24.9867 30.2667 24.5201 30.2667 23.9467C30.2667 23.3734 29.8 22.9054 29.2267 22.9054H18.7733C18.1987 22.9054 17.7333 23.3734 17.7333 23.9467C17.7333 24.5201 18.1987 24.9867 18.7733 24.9867ZM18.7733 31.0801H29.2267C29.7587 31.0268 30.16 30.5721 30.16 30.0401C30.16 29.4934 29.7587 29.0401 29.2267 28.9867H18.7733C18.3733 28.9467 17.9867 29.1334 17.7733 29.4801C17.56 29.8134 17.56 30.2534 17.7733 30.6001C17.9867 30.9334 18.3733 31.1334 18.7733 31.0801Z" :fill="tab==='tab-1'?'#D20003':'black'"/>
          </svg>

        </v-tab>
        <v-tab href="#tab-2">
          <div v-if="tab==='tab-2'">درحال انجام</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.227 10.6665H29.787C34.307 10.6665 37.3337 13.8398 37.3337 18.5598V29.4532C37.3337 34.1598 34.307 37.3332 29.787 37.3332H18.227C13.707 37.3332 10.667 34.1598 10.667 29.4532V18.5598C10.667 13.8398 13.707 10.6665 18.227 10.6665ZM18.027 25.5998C17.147 25.5998 16.427 24.8798 16.427 23.9998C16.427 23.1198 17.147 22.4012 18.027 22.4012C18.907 22.4012 19.627 23.1198 19.627 23.9998C19.627 24.8798 18.907 25.5998 18.027 25.5998ZM22.4003 23.9998C22.4003 24.8798 23.1203 25.5998 24.0003 25.5998C24.8803 25.5998 25.6003 24.8798 25.6003 23.9998C25.6003 23.1198 24.8803 22.4012 24.0003 22.4012C23.1203 22.4012 22.4003 23.1198 22.4003 23.9998ZM28.3737 23.9998C28.3737 24.8798 29.0937 25.5998 29.9737 25.5998C30.8537 25.5998 31.5603 24.8798 31.5603 23.9998C31.5603 23.1198 30.8537 22.4012 29.9737 22.4012C29.0937 22.4012 28.3737 23.1198 28.3737 23.9998Z" :fill="tab==='tab-2'?'#D20003':'black'"/>
          </svg>
        </v-tab>
        <v-tab href="#tab-3">
          <div v-if="tab==='tab-3'">پایان یافته</div>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="24" fill="#DFDFDF"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.227 10.6665H29.787C34.307 10.6665 37.3337 13.8398 37.3337 18.5598V29.4545C37.3337 34.1598 34.307 37.3332 29.787 37.3332H18.227C13.707 37.3332 10.667 34.1598 10.667 29.4545V18.5598C10.667 13.8398 13.707 10.6665 18.227 10.6665ZM23.2403 27.9865L29.5737 21.6532C30.027 21.1998 30.027 20.4665 29.5737 19.9998C29.1203 19.5465 28.3737 19.5465 27.9203 19.9998L22.4137 25.5065L20.0803 23.1732C19.627 22.7198 18.8803 22.7198 18.427 23.1732C17.9737 23.6265 17.9737 24.3598 18.427 24.8265L21.6003 27.9865C21.827 28.2132 22.1203 28.3198 22.4137 28.3198C22.7203 28.3198 23.0137 28.2132 23.2403 27.9865Z" :fill="tab==='tab-3'?'#D20003':'black'"/>
          </svg>
        </v-tab>
      </v-tabs>
        <v-data-table hide-default-footer :headers="headers"
                      item-value="name" :items-per-page="20"
                      :loading="receiving_orders" :items="orders.results"
                      mobile-breakpoint="0"
                      loading-text="درحال دریافت اطلاعات ..."
                      no-data-text="لیست خریدی موجود نیست!"
        >
            <template v-slot:item="{ item, index }">

              <tr v-if="index === 0">
                <td colspan="7" class="text-center" style="padding: 0;background-color: #4caf50;height: 2em;color: white;">
                  <strong>
                    {{ new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR') }}
                  </strong>
                </td>
              </tr>

              <tr @click="handler_click_row(item)" style="cursor: pointer">
                <td class="text-center">#{{ item.id }}</td>
                <td>{{ item.title }}</td>
                <td>
                  <v-tooltip v-if="item.des && item.des.length > 40" top color="gray" max-width="50em">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{ item.des.slice(0, 40) + '...' }}
                      </div>
                    </template>
                    <span>{{ item.des }}</span>
                  </v-tooltip>
                  <div v-else>
                    {{ item.des }}
                  </div>
                </td>
                <td class="text-center">
                  <v-chip outlined>{{ item.location }}</v-chip>
                </td>

                <td class="text-center">
                  <v-tooltip top color="red">
                    <template v-slot:activator="{ on, attrs }">
                      <a v-bind="attrs" v-on="on">
                        {{ new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR') }}
                      </a>
                    </template>
                    <span>{{ convert_en_to_fa_number(item.created_at.split('T')[1].split('.')[0]) }}</span>
                  </v-tooltip>
                </td>
                <td class="text-center">
                  <v-avatar class="rounded-circle my-5">
                    <v-img v-if="item.created_user['profile_picture']" :src="item.created_user['profile_picture']"
                           alt="profile_pic" width="50px" height="50px"></v-img>
                  </v-avatar>
                  <template v-if="!item.created_user.first_name && !item.created_user.last_name">
                    {{ item.created_user.username}}
                  </template>
                  {{ `${item.created_user.first_name} ${item.created_user.last_name}` }}
                </td>
              </tr>

              <tr v-if="orders.results.length !== index && item.created_at.split('T')[0] !== orders.results[orders.results.length>index+1?index+1:index]['created_at'].split('T')[0]">
                <td colspan="7" class="text-center" style="padding: 0;background-color: #4caf50;height: 2em;color: white;">
                  <strong>
                      {{ new Date(orders.results[index+1].created_at.split('T')[0]).toLocaleDateString('fa-IR') }}
                  </strong>
                </td>
              </tr>



            </template>

        </v-data-table>
        <template v-if="orders.results && orders.count > 20" >
              <div class="text-center mt-3">
                <v-pagination v-model="page" color="#D20003" rounded @input="$emit('change_page', page)"
                              :length="orders.count % 20 !== 0 ? parseInt(orders.count / 20) + 1 : parseInt(orders.count / 20)"
                              :total-visible="7"></v-pagination>
              </div>
        </template>
        <orderDetail :order="order_d.order" :show_detail="order_d.show_detail"
                    @close="close_detail_view()"
        />
    </div>
</template>

<script>
import orderDetail from "@/components/Orders/order-detail.vue";

export default {
  name: "OrdersList",
    props: ['orders', 'receiving_orders', 'page', 'is_searched'],
    components: { orderDetail },
    data: () => ({
        order_d: {},
        tab: 'tab-1',
        headers: [
            {key: 'num', text: 'کد',sortable: false, align: 'center', value: 'id' },
            {key: 'title', text: 'نام',sortable: false, align: 'right', value: 'title' },
            {key: 'des', text: 'شرح', sortable: false, align: 'right', value: 'des' },
            {key: 'location', text: 'مکان',sortable: false, align: 'center', value: 'location' },
            {key: 'created_at', text: 'زمان ثبت',sortable: false, align: 'center', value: 'created_at' },
            {key: 'created_user', text: 'ساخته شده توسط',sortable: false, align: 'center', value: "created_user" },
        ]
    }),
    methods: {
      close_detail_view(){
        this.order_d.show_detail=false;
        this.$emit('refresh_orders');
      },
      handler_click_row(order) {
          this.order_d = { order: order, show_detail: true }
      },
    }
}
</script>
